import { LayoutChangeEvent } from 'react-native'
import { SharedValue, WithSpringConfig } from 'react-native-reanimated'

export type SegmentedOption<T extends string | number> = {
  id: T
  label: string
  disabled?: boolean
}

export interface SegmentedProps<T extends string | number> {
  options?: SegmentedOption<T>[]
  disabled?: boolean
  onChange?: (value: SegmentedOption<T>) => void
  value?: SegmentedOption<T>
  classNameOption?: string
}

export interface SegmentedItemProps<T extends string | number> {
  option: SegmentedOption<T>
  isSelected: boolean
  isDisabled: boolean
  index: number
  animation: SharedValue<number>
  // Selection presence (0..1): gates the active label so nothing reads as
  // selected while the indicator is hidden.
  selection: SharedValue<number>
  classNameOption?: string
  onChange?: (value: SegmentedOption<T>) => void
  onLayout: (event: LayoutChangeEvent, option: SegmentedOption<T>) => void
}

export const animationConfig = {
  mass: 1,
  damping: 100,
  stiffness: 200,
  overshootClamping: false,
} satisfies WithSpringConfig
